import { STORAGE_KEYS } from 'constants/storageKeys';
import { storage } from 'util/storage';

/** Single place that owns auth token persistence. */
export const tokenManager = {
  getToken: () => storage.get(STORAGE_KEYS.TOKEN),
  setToken: (token) => storage.set(STORAGE_KEYS.TOKEN, token),
  getRefreshToken: () => storage.get(STORAGE_KEYS.REFRESH_TOKEN),
  setRefreshToken: (token) => storage.set(STORAGE_KEYS.REFRESH_TOKEN, token),
  clear: () => {
    storage.remove(STORAGE_KEYS.TOKEN);
    storage.remove(STORAGE_KEYS.REFRESH_TOKEN);
    storage.remove(STORAGE_KEYS.USER);
    storage.remove(STORAGE_KEYS.ROLE);
    // Both logout paths (manual, and the httpClient 401 auto-logout) funnel
    // through here, so this is the one place that guarantees the master
    // sidebar's "show selected module only" choice resets on every logout —
    // a fresh login always starts back at its narrowed default.
    storage.remove(STORAGE_KEYS.MASTER_SIDEBAR_VIEW);
  },
};

export default tokenManager;
